import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const HISTORY_OPENED_STATE = 'historyOpenedState';

export const useCoinsHistoryOpenedState = () => {
  const {isOpen, open, cancel} = useOpenedStateManager(HISTORY_OPENED_STATE);

  return {
    isOpen,
    open,
    cancel,
  };
};
